import script from "./UserPage.vue?vue&type=script&setup=true&lang=js"
export * from "./UserPage.vue?vue&type=script&setup=true&lang=js"

import "./UserPage.vue?vue&type=style&index=0&id=5bfc8d17&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bfc8d17"]])

export default __exports__